export default __webpack_public_path__ + "static/media/33.8b1e13d2.png";